import React, { useState, useEffect, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import {AiFillCloseCircle} from "react-icons/ai"
import About from "../layouts/About";
import { registerObj } from "../services/register-services";
import "../styles/about-animate.css";
import styles from "../styles/register.module.css";

const RegisterComponent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [statusElement, setStatusElement] = useState({
    title: "",
    message: "",
    isSuccess: false,
  });
  const [formElement, setFormElement] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const redirect = () => {
    window.open("https://human-challenge.web.app/register", "_blank");
  };

  const openModalHandler = () => {
    setOpenModal(true);
  };

  const closeModalHandler = () => {
    setOpenModal(false);
  };

  const handleFormChange = (e) => {
    setFormElement({ ...formElement, [e.target.name]: e.target.value });
  };

  const submitFormHandler = async () => {
    if (formElement.email.length > 0 && formElement.name.length > 0) {
      try {
        const response = await registerObj.create(formElement);
        if (response) {
          const form = {
            title: "Submission Successful",
            message:
              "Your request has been received. We will get back to you shortly",
            isSuccess: true,
          };
          setStatusElement(form);
          setStatusModal(true);

          setTimeout(() => {
            setStatusModal(false);
            setOpenModal(false);
          }, 4000);
        }
      } catch (error) {
        const form = {
          title: "Submission failed",
          message: "Error in submitting form",
          isSuccess: false,
        };
        setStatusElement(form);
        setStatusModal(true);

        setTimeout(() => {
          setStatusModal(false);
          setOpenModal(false);
        }, 4000);
      }
    } else {
      alert("Please enter a valid email address and name.");
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.7 } // Adjust the threshold as needed
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    // Cleanup the observer
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div className="about-section" ref={sectionRef}>
      <CSSTransition in={isVisible} timeout={500} classNames="about-transition">
        <div className={styles["register-container"]}>
          <h1>Join the Revolution Now!</h1>
          <div className={styles["button-group"]}>
            <button className={styles["login"]} onClick={() => redirect()}>
              Login
            </button>
            <button
              className={styles["register"]}
              onClick={() => openModalHandler()}
            >
              Register Interest
            </button>
          </div>
          {openModal && (
            <div
              className={styles["modal-container"]}
              id="myModal"
              onClick={(e) =>
                e.target === document.getElementById("myModal")
                  ? setOpenModal(false)
                  : null
              }
            >
              <div className={styles["modal-content"]}>
                <div className={styles["register-title-close"]}>
                  <AiFillCloseCircle className={styles["close-cirlce"]} onClick={()=>closeModalHandler()}/>
                </div>
                <div className={styles["register-title"]}>
                  <h1 className={styles["modal-title"]}>Register</h1>
                </div>
                <div className={styles["modal-form"]}>
                  <div className={styles["form-group"]}>
                    <p>Name</p>
                    <input
                      type="text"
                      name="name"
                      onChange={(e) => handleFormChange(e)}
                    />
                  </div>
                  <div className={styles["form-group"]}>
                    <p>Email Address</p>
                    <input
                      type="email"
                      name="email"
                      onChange={(e) => handleFormChange(e)}
                    />
                  </div>
                  <div className={styles["form-group"]}>
                    <p>Phone</p>
                    <input
                      type="text"
                      name="phone"
                      onChange={(e) => handleFormChange(e)}
                    />
                  </div>
                  <div className={styles["form-group"]}>
                    <p>Message</p>
                    <textarea
                      rows={5}
                      name="message"
                      onChange={(e) => handleFormChange(e)}
                    />
                  </div>
                  <div className={styles["button-div"]}>
                    <button
                      className={styles["register-button"]}
                      onClick={() => submitFormHandler()}
                    >
                      Register
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {statusModal && (
            <div className={styles["modal-container"]}>
              <div className={styles["status-content"]}>
                <div className={styles["header-title"]}>
                  {statusElement.title}
                </div>
                <div className={styles["sub-title"]}>
                  {statusElement.message}
                </div>
                <div className={styles["status"]}>
                  {statusElement.isSuccess ? (
                    <img
                      className={styles["image"]}
                      src="https://human-website.b-cdn.net/check.gif"
                      alt="success"
                    />
                  ) : (
                    <img
                      className={styles["image"]}
                      src="https://human-website.b-cdn.net/error.gif"
                      alt="error"
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </CSSTransition>
    </div>
  );
};
export default RegisterComponent;
